export enum cardType {
    Default = "Default",
    Clipboard = "Clipboard"
}